// src/reducers/authentication.reducer.js

import config from "config";
import LZString from "lz-string";

import { userConstants } from "../constants";
import { setGlobalClientId, setSessionClientId } from "../helpers/client";

let user;

try {
  const raw = localStorage.getItem(
    `ads.user.id.key${config.adsMsalConfig.clientID}`,
  );
  if (raw) {
    const decompressed = LZString.decompressFromUTF16(raw);
    if (decompressed) {
      const parsed = JSON.parse(decompressed);
      if (parsed && parsed.id) {
        user = parsed;
      } else {
        // Corrupt/incomplete user payload; drop to ensure clean re-finalization
        user = undefined;
      }
    }
  }
} catch (_e) {
  // If storage is corrupt, clear and fall back to unauthenticated state
  try {
    localStorage.removeItem(
      `ads.user.id.key${config.adsMsalConfig.clientID}`,
    );
  } catch (_e2) {
    // ignore
  }
  user = undefined;
}

const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  if (action && action.type) {
    switch (action.type) {
      case userConstants.EMAIL_LOGIN_REQUEST:
        return { emailLoggingIn: true, user: action.msalUser };
      case userConstants.EMAIL_LOGIN_SUCCESS:
        setGlobalClientId(action.msalUser);
        return { emailLoggingIn: false, user: action.msalUser };
      case userConstants.EMAIL_LOGIN_FAILURE:
        setSessionClientId();
        return {};
      case userConstants.LOGOUT:
        setSessionClientId();
        return { loggingOut: true };

      case userConstants.MSAL_LOGIN_REQUEST:
        return { msalLoggingIn: true, user: action.msalLogin };
      case userConstants.MSAL_LOGIN_SUCCESS:
        setGlobalClientId(action.msalUser);
        return { msalLoggingIn: false, user: action.msalUser };
      case userConstants.MSAL_LOGIN_FAILURE:
        setSessionClientId();
        return { loggingOut: true };

      default:
        return state;
    }
  }
}
